import { LOCALES } from "../locales";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOCALES.HEBREW]: {
    //COMMON
    commonBackToTheMainPage: "חזרה לעמוד הראשי",
    commonBackToOrganizersPage: "חזרה לרשימת המארגנים",
    hideRows: "10 שורות ראשונות הוסתרו",

    //HEADER
    headerDevicesConnected: "מחובר לפאנל",
    headerOptToUsers: "הגדר משתמש OTP",
    headerOpenProfiles: "פתח פרופילים",
    headerOpenOrganizers: "פותחים מארגנים",
    headerOpenOrganizersRequest: "פתיחת בקשות מארגנים",
    headerOpenDocuments: "פתח מסמכים",
    headerOpenTransactions: "לעסקאות",
    headerTotalMoney: "סך הכל כסף",
    headerTotalFee: "עמלה כוללת",
    headerTransactionTotalFee: "עמלת עסקה",
    headerTransactionTotalFastFee: "עמלת עסקה מהירה",
    headerTransactionTotalEarlyFee: "עמלת עסקה מוקדמת",
    headerDownloadReport: "דו״ח",
    headerCancelTicket: "ביטול כרטיס",

    // SEND OTP MODAL
    otpCode: "קוד אופטימיזציה למשתמש",
    setOtp: "הגדר OTP",
    otpSetSuccess:
      "קוד OTP לעג למשתמש למשך 60 הדקות הבאות והקוד הועתק ללוח שלך",
    otpSetFailed: "קוד OTP נכשל",

    //DEVICES MODAL
    devicesModalTitle: "מכשירים פעילים",
    otpModalTitle: "הגדר משתמש OTP",
    robotCreditsModalTitle: "שנה נקודות SMS לרובוט משתמש",
    devicesModalActionDisconnectSuccess: "ניתוק המכשיר הצליח",
    devicesModalActionDisconnectFailure: "שגיאת ניתוק מכשיר",

    //ADD PAYMENT MODAL
    apModalTitle: "הוסף תשלום חדש",
    apModalDropFileHere: "שחרר את הקובץ כאן",
    apModalDragFileHere: "גרור את הקובץ לכאן",
    apModalUploadFile: "העלה קובץ",
    apModalReUploadFile: "העלה מחדש את הקובץ",

    //FILTER
    filterTitle: "לסנן",
    filterItemOnlyPaid: "אירועים ששולמו",
    filterItemSortByName: "מיין לפי שם",
    filterItemAscending: "עולה",
    filterSubmit: "שלח",
    filterRestore: "לשחזר",
    filterSearch: "לחפש",

    //CUSTOM DATE RANGE PICKER
    cdrpFrom: "מ...",
    cdrpTo: "ל...",

    //CUSTOM DATAGRID
    customDataGridLoadMore: "טען עוד",

    // EVENTS STATUS NAV
    esnWaitingForConfirm: "מחכה לאישור",
    esnDeletedEvents: "שנמחקו",
    esnFinishedEvents: "שהסתיימו",
    esnFinishedUnpaidEvents: "ללא תשלום",
    esnHiddenEvents: "נסתרים",
    esnAllEvents: "כל האירועים",
    esnActiveEvents: "פעילים",
    esnCanceledEvents: "שבוטלו",
    esnInProgressEvents: "בתהליך",
    esnCurrentWeekEvents: "השבוע הנוכחי",

    //#region PROFILES
    gridProfilesTotalClearances: "סך סליקה כולל",
    gridProfilesTotalPurchases: "סך כל הרכישות",
    gridProfilesAmountOfPurchasedTickets: "כמות הכרטיסים שנרכשו",
    gridProfilesAmountOfEvents: "כמות אירועים",
    gridProfilesProducerAndIdentityCardOrHPAndPhoneNumber: "מידע מפיק",
    gridProfilesCreatorOfTheEvent: "יוצר האירוע",
    gridProfilesPostalCode: "מיקוד",
    gridProfilesCellphoneNumber: "מספר טלפון סלולארי",
    gridProfilesLinkToProfile: "קישור לפרופיל",
    gridProfilesDeletedUser: "משתמש שנמחק",
    gridProfilesChangeRobotSmsCredits: "שנה קרדיט SMS רובוט",
    gridProfilesChangeRobotSmsCreditsCount: "קרדיט SMS רובוט:",
    gridProfilesChangeRobotSmsAccess: "רובוט עדכונים",
    gridProfilesRestoreUser: "שחזר משתמש",
    gridProfilesAutoConfirmationUser: "אישור אוטומטי",

    buttonDownloadAllInformation: "הורד את כל המידע",
    profilesDeletedProfiles: "פרופילים שנמחקו",
    profilesAllProfiles: "כל הפרופילים",
    profilesTotalCreditsCountL: 'רובוט SMS סה"כ קרדיטים:',
    //#endregion

    //ALL EVENTS
    gridEventsOpenAsOwner: "פתוח כבעלים",
    gridEventsPaymentStatus: "סטטוס תשלום",
    gridEventsPaymentStatusIsPaidCheckBox: "שולם",
    gridEventsOrderConfirmation: "אישור תשלום",
    gridEventsFile: "קובץ",
    gridEventsReceiptFile: "קובץ קבלות",
    gridEventsInvoiceFile: "קובץ חשבונית",
    gridEventsBankAccountInfo: "פרטי חשבון בנק",
    gridEventsBankAccountInfoNumber: "מס' בנק",
    gridEventsBankAccountInfoAccountNumber: "מס חשבון",
    gridEventsBankAccountFullName: "שם מלא",
    gridEventsTotalCommisionProfit: 'סה"כ רווח עמלה',
    gridEventsTotalTicketsPurchasedInCredit: "סך הכל כסף ללא עמלה",
    gridEventsTotalTicketsSold: 'סה"כ כרטיסים שנמכרו',
    gridEventsTotalTicketsSoldInCredit: "כרטיסים שנמכרו באשראי",
    gridEventsCanceledMoney: "כמות כסף שהוחזרה עקב בקשות ביטול",
    gridEventsCanceledCount: "כמות כרטיסים עם בקשת החזר",
    gridEventsReturnedMoney: "כסף שהוחזר",
    gridEventsReturnedCount: "כמות כרטיסים שבוטלו",
    gridEventsProducerAndIdentityCardOrHPAndPhoneNumber: "פרטי הפרופיל",
    gridEventsCreatorName: "היוצר של האירוע",
    gridEventsCreatorAddress: "מיקוד",
    gridEventsCreatorPhone: "מספר טלפון סלולארי",
    gridEventsStartDate: "תאריך האירוע",
    gridEventsCreateDate: "תאריך תחילת המכירה",
    gridEventsName: "שם האירוע",
    gridEventsStatus: "מצב האירוע",
    gridEventsStatusDeleted: "אירוע שנמחק",
    gridEventsStatusHidden: "אירוע נסתר",
    gridEventsStatusHighPriority: "עדיפות גבוהה",
    gridEventsRepeatEvent: "חזור על אירוע",
    gridEventsShowEvent: "הצג אירוע",
    gridEventsConfirmEvent: "אשר את האירוע",
    gridEventsDeleteEvent: "מחק אירוע",

    //TRANSACTIONS
    invoiceTotalInvoicesBeforeVAT: 'סך החשבוניות לפני מע"מ',
    invoiceTotalVAT: 'סך המע"מ',
    invoiceTotalInvoicesIncluded: "סך כל החשבוניות כלולות",
    invoiceThisEventHasNoSuchFiles: "לאירוע הזה אין קבצים כאלה",
    transactionsInvoices: "חשבוניות",
    transactionsConfirm: "אישורים",
    transactionsCancelled: "מבוטל",
    transactionsFetchError: "אירעה שגיאה בעת טעינת הדף",

    //LOGIN
    loginEnterNumber: "הזן את מספר הטלפון שלך כאן",
    loginSendCode: "שלח קוד באמצעות SMS",
    loginEnterCode: "הזן את קוד ההסכמה שלך כאן",
    loginVerifyCode: "אמת קוד OTP",
    loginCodeSendSuccess: "OTP נשלח בהצלחה",
    loginCodeInvalid: "קוד לא תקין",
    loginError: "שגיאה",

    organizersAllOrganizers: "כולם",
    organizersActiveOrganizers: "פעילים",
    organizersNotActiveOrganizers: "לא פעילים",

    organizersTotalCount: "סה״כ מארגנים:",
    organizersButtonDownloadExcel: "הורד אקסל",
    organizersButtonDownloadShortExcel: "הורד מידע קצר",

    gridOrganizersOrganizerInfo: "פרטי מארגן",
    gridOrganizersName: "שם מלא:",
    gridOrganizersPhone: "טלפון:",
    gridOrganizersEmail: "אימייל:",
    gridOrganizersIDcode: "תעודת זהות:",

    gridOrganizersOrganizerEventsInfo: "פרטי אירועים",
    gridOrganizersTotalEventsCount: "סה״כ אירועים:",
    gridOrganizersActiveEventsCount: "אירועים פעילים:",
    gridOrganizersFinishedEventsCount: "אירועים שהסתיימו:",
    gridOrganizersCancelledEventsCount: "אירועים שבוטלו:",
    gridOrganizersPendingEventsCount: "אירועים ממתינים:",

    gridOrganizersOrganizerEventsActivityInfo: "מידע על פעילות האירועים",
    gridOrganizersTotalTicketsSoldCount: "סה״כ כרטיסים:",
    gridOrganizersTotalTicketsSoldMoney: "סה״כ כסף מכרטיסים:",
    gridOrganizersTotalTicketsSoldFee: "סה״כ עמלות מכרטיסים:",
    gridOrganizersActivePeriodTotalTicketsSoldCount:
      "כרטיסים שנמכרו ב-60 הימים האחרונים:",
    gridOrganizersActivePeriodTotalTicketsSoldMoney:
      "כסף מכרטיסים ב-60 הימים האחרונים:",
    gridOrganizersActivePeriodTotalTicketsSoldFee: "עמלות ב-60 הימים האחרונים:",

    gridOrganizersOrganizerActivityInfo: "מידע על פעילות",
    gridOrganizersJoinDate: "תאריך הצטרפות:",
    gridOrganizersLastEventDate: "תאריך האירוע האחרון:",
    gridOrganizersStatus: "סטטוס:",
    gridOrganizersStatusActive: "פעיל 😊",
    gridOrganizersStatusNotActive: "לא פעיל 🤔",

    gridOrganizersSettings: "הגדרות",
    gridOrganizersChangeRobotSmsCreditsCount: "יתרת SMS רובוטי:",
    gridOrganizersChangeRobotSmsCredits: "שנה יתרת SMS רובוטי",
    gridOrganizersChangeRobotSmsAccess: "גישה ל-SMS רובוטי",
    gridOrganizersAutoConfirmationUser: "אישור אוטומטי",

    // Other
    changeUserCredits: "עדכן את קרדיט ה-SMS של רובוט המשתמש",
    updateCreditsError: "שגיאה. נסה שוב בבקשה.",

    downloadReportModalTitle: "להוריד דו״ח אירועים",
    ignoreYeshInvoiceText: "התעלם YeshInvoice",
    ignoreTransactionsText: "התעלם מעסקאות",
    ignoreZCreditText: "התעלם ZCredit",
    downloadReportFromDate: "מתאריך",
    downloadReportToDate: "עד תאריך",
    downloadReport: 'הורדת דו"ח',
    downloadReportError: "אירעה שגיאה בהורדת הדו״ח",

    cancelTicketModalTitle: "ביטול כרטיס",
    phoneNumberPlaceholder: "מספר טלפון",
    eventLinkPlaceholder: "קישור לאירוע",
    searchTickets: "חיפוש כרטיסים",
    backToSearch: "חזרה לחיפוש",
    buyerUser: "רוכש הכרטיס",
    ticketUser: "משתמש הכרטיס",
    ticketInfo: "פרטי הכרטיס",
    price: "מחיר",
    feePrice: "עמלה",
    cardHolder: "שם בעל הכרטיס",
    cardNumber: "מספר כרטיס",
    ticketStatus: "שינוי סטטוס כרטיס",
    returnMoney: "החזר כספי (ZCredit)",
    sendSms: "שלח SMS",
    yeshInvoiceDocs: "צור מסמכים ל־ (YeshInvoice)",
    fullReturn: "החזר כספי מלא (כולל עמלה)",
    changeTicketStatus: "שנה סטטוס כרטיסים",
    backToList: "חזרה לרשימה",
    ticketChangedSuccess: "סטטוס הכרטיסים עודכן בהצלחה",

    organizerSettingsAdminNote: "הערת מנהל לגבי המארגן",
    organizerSettingsModalTitle: "עדכון הגדרות מארגן",
    organizerFreeTransactionCount: "מספר עסקאות חינם",
    organizerTransactionFee: "עמלת עסקה",
    organizerFastWithdrawalFee: "עמלת משיכה מהירה",
    organizerTransactionMinSum: "סכום מינימום לעסקה",
    organizerEarlyWithdrawalEnabled: "משיכה מוקדמת",
    organizerEarlyWithdrawalPercent: "אחוז משיכה מוקדמת",
    organizerEarlyWithdrawalDays: "ימי משיכה מוקדמת",
    organizerEarlyWithdrawalFee: "עמלת משיכה מוקדמת",
    organizerWithdrawalTypeDefault: "ברירת מחדל",
    organizerWithdrawalTypeDays: "לפי ימים",
    organizerWithdrawalDays: "ימי משיכה",
    organizerUpdateSettings: "עדכן הגדרות",
    organizerFreeTransactionCountMinError: "מספר מינימום לעסקאות חינם הוא 0",
    organizerFreeTransactionCountRequiredError: "חובה להזין מספר עסקאות חינם",
    organizerTransactionFeeMinError: "עמלת עסקה מינימלית היא 0",
    organizerTransactionFeeRequiredError: "חובה להזין עמלת עסקה",
    organizerFastWithdrawalFeeMinError:
      "העמלה למשיכה מהירה חייבת להיות לפחות 0",
    organizerFastWithdrawalFeeRequiredError: "נדרשת עמלה למשיכה מהירה",
    organizerTransactionMinSumMinError: "סכום מינימום לעסקה הוא 0",
    organizerTransactionMinSumRequiredError: "חובה להזין סכום מינימום לעסקה",
    organizerEarlyWithdrawalPercentMinError: "אחוז מינימום לעסקה הוא 0",
    organizerEarlyWithdrawalPercentMaxError: "אחוז מקסימום לעסקה הוא 100",
    organizerEarlyWithdrawalPercentRequiredError:
      "חובה להזין אחוז משיכה מוקדמת",
    organizerEarlyWithdrawalDaysMinError:
      "מספר ימים מינימלי למשיכה מוקדמת הוא ‎-365",
    organizerEarlyWithdrawalDaysMaxError:
      "מספר ימים מקסימלי למשיכה מוקדמת הוא 365",
    organizerEarlyWithdrawalDaysRequiredError:
      "חובה להזין מספר ימים למשיכה מוקדמת",
    organizerEarlyWithdrawalFeeMinError:
      "אחוז מינימום לעמלת משיכה מוקדמת הוא 0",
    organizerEarlyWithdrawalFeeMaxError:
      "אחוז מקסימום לעמלת משיכה מוקדמת הוא 100",
    organizerEarlyWithdrawalFeeRequiredError: "חובה להזין עמלת משיכה מוקדמת",
    organizerWithdrawalDaysMinError: "מספר ימים מינימלי למשיכה הוא 0",
    organizerWithdrawalDaysRequiredError: "חובה להזין מספר ימים למשיכה",

    transactionAll: "הכל",
    transactionPending: "ממתין",
    transactionWithdrawn: "נמשך",
    transactionRejected: "נדחה",
    transactionCancelled: "בוטל",
    transactionInProgress: "בביצוע",
    transactionFast: "מהיר",

    showTransactions: "הצג עסקאות",

    gridEventTransactionListTransactionNameInfo: "מידע כללי",
    gridEventTransactionListTransactionName: "שם העסקה",
    gridEventTransactionListTransactionDescription: "הערת עסקה",
    gridEventTransactionListTransactionAdminDescription: "הערת מנהל לעסקה",

    gridEventTransactionListEventInfo: "מידע על האירוע",
    gridEventTransactionListEventName: "שם האירוע",
    gridEventTransactionListEventStartDate: "תאריך התחלת האירוע",
    gridEventTransactionListEventEndDate: "תאריך סיום האירוע",
    gridEventTransactionListEventShowInfo: "הצג מידע",

    gridEventTransactionListOrganizerInfo: "מידע על המארגן",
    gridEventTransactionListOrganizerName: "שם מלא",
    gridEventTransactionListOrganizerPhone: "טלפון",
    gridEventTransactionListShowOrganizerInfo: "הצג מידע",

    gridEventTransactionListTransactionInfo: "מידע על העסקה",
    gridEventTransactionListItemLastTransaction: "עסקת אירוע אחרונה",
    gridEventTransactionListItemFastWithdrawal: "משיכה מהירה",
    gridEventTransactionListItemEarlyWithdrawal: "משיכה מוקדמת",
    gridEventTransactionListItemTotal: "סכום כולל",
    gridEventTransactionListItemAmount: "סכום משיכה",
    gridEventTransactionListItemFee: "עמלת עסקה",
    gridEventTransactionListItemEarlyFee: "עמלת משיכה מוקדמת",
    gridEventTransactionListItemFastFee: "עמלת משיכה מהירה",

    gridEventTransactionListBillAccountInfo: "פרטי חשבון בנק",
    gridEventTransactionListBillAccountName: "שם",
    gridEventTransactionListBillAccountDescription: "תיאור",
    gridEventTransactionListBillAccountHolderName: "שם בעל החשבון",
    gridEventTransactionListBillAccountBankName: "שם הבנק",
    gridEventTransactionListBillAccountBankNumber: "מספר הבנק",
    gridEventTransactionListBillAccountBankAccountNumber: "מספר חשבון בנק",
    gridEventTransactionListBillAccountIdCode: "קוד זיהוי",

    gridEventTransactionListTransactionDates: "תאריכי העסקה",
    gridEventTransactionListRequestDate: "תאריך בקשה",
    gridEventTransactionListLastChangeDate: "תאריך שינוי אחרון",
    gridEventTransactionListStatus: "סטטוס",
    gridEventTransactionListStatusWithdrawn: "נמשך",
    gridEventTransactionListStatusPending: "ממתין",
    gridEventTransactionListStatusRejected: "נדחה",
    gridEventTransactionListStatusCancelled: "בוטל",

    gridEventTransactionListActions: "פעולות",
    gridEventTransactionListMoveToInProgressTransaction: "העבר לבביצוע",
    gridEventTransactionListInProgress: "העסקה בביצוע",
    gridEventTransactionListApproveTransaction: "אישור עסקה",
    gridEventTransactionListDeclineTransaction: "דחיית עסקה",
    gridEventTransactionListDownloadTransactionReceiptPdf:
      "הורד מסמך משיכה ב-PDF",
    gridEventTransactionListDownloadTransactionFeePdf: "הורד קובץ PDF של העמלה",
    gridEventTransactionListDownloadTransactionEarlyWithdrawalFeePdf:
      "הורד קובץ PDF של עמלת משיכה מוקדמת",
    gridEventTransactionListDownloadTransactionFastWithdrawalFeePdf:
      "הורד קובץ PDF של עמלת המשיכה המהירה",

    gridOrganizerRequestListRequestInfo: "מידע על הבקשה",
    gridOrganizerRequestListRequestMessage: "הודעת בקשה",
    gridOrganizerRequestListRequestDate: "תאריך בקשה",
    gridOrganizerRequestListActions: "פעולות",
    gridOrganizerRequestListApproveRequest: "אישור בקשה",
    gridOrganizerRequestListDeclineRequest: "דחיית בקשה",

    approveTransaction: "אשר עסקה",
    declineTransaction: "דחה עסקה",
    adminNotePlaceholder: "השאר הערת מנהל",
    approveRequest: "אשר בקשה",
    declineRequest: "דחה בקשה",
    cancel: "ביטול",

    gridEventsCrossQRScanner: "הצג הגדרות QR",
    eventCrossQRScannerModalTitle: "עדכון הגדרות סורק QR חוצה אירועים",
    relatedEventLink: "קישור לאירוע קשור",
    addRelatedScannerEvent: "הוסף עוד אחד",
    updateRelatedScannerEvent: "עדכן הגדרות סורק QR של האירוע",
    relatedEventLinkRequiredError: "נדרש קישור לאירוע קשור",
    relatedEventsSuccessUpdated: "האירועים הקשורים עודכנו בהצלחה",

    usersRequiredError: "שדה חובה",
    usersFormatError:
      "כל שורה חייבת להיות בפורמט: phone,name,surname[,count[,IDcode]]",
    usersColumnsCountError: "שורה {n}: הציפייה לפורמט טלפון,שם,שם משפחה",
    usersPhoneRequiredError: "שורה {n}: נדרש מספר טלפון",
    usersPhoneInvalidError: "שורה {n}: מספר טלפון לא תקין",
    usersNameRequiredError: "שורה {n}: נדרש שם פרטי",
    usersSurnameRequiredError: "שורה {n}: נדרש שם משפחה",
    usersCountInvalidError: "שורה {n}: count חייב להיות מספר שלם וחיובי",
    usersIdCodeInvalidError: "שורה {n}: ID code מכיל תווים לא חוקיים",
    smsRequiredError: "נדרש טקסט SMS",
    smsTextMustContainTicketLinkError: "טקסט ה-SMS חייב לכלול %LINK_TO_TICKET%",

    giftNoneOption: "לא נבחר",
    gridEventsGiftTickets: "כרטיסי מתנה",
    ticketsSuccessGifted: "הכרטיס הוענק בהצלחה",
    eventGiftTicketsModalTitle: "הענקת כרטיסים",
    giftUsersHelper: "פורמט שורה: טלפון,שם,שם משפחה,כמות,קוד זיהוי",
    giftUsers: "משתמשים להענקה",
    giftSmsTextHelper:
      "לטקסט ה-SMS חובה לכלול את המשתנה %LINK_TO_TICKET% ואפשרי להוסיף %EVENT_NAME%",
    giftSmsText: "טקסט SMS",
    giftTicketHelper:
      'ניתן לבחור כרטיס קיים או להוסיף שם (כרטיס ייווצר אוטומטית לרשימת המשתמשים), שם ברירת מחדל "כרטיס מתנה לאירוע"',
    giftTicketSelect: "בחר כרטיס (אופציונלי)",
    giftTicketName: "שם כרטיס (אופציונלי)",
    giftTickets: "כרטיסי מתנה",

    organizerEventFeeMinError: "אחוז דמי האירועים המינימלי הוא 0",
    organizerEventFeeMaxError: "אחוז דמי האירועים המקסימלי הוא 100",
    organizerEventFeeRequiredError: "נדרש להזין אחוז דמי אירועים",
    updateFeePercentError:
      "אירעה שגיאה בעת ניסיון לעדכן את דמי האירועים של המארגן",
    organizerSettingsEventFeePercentModalTitle: "דמי אירועים של המארגן",
    organizerEventFee: "דמי אירועים",
    organizerUpdateEventFeeSettings: "עדכון דמי אירועים",

    organizerFilesModalTitle: "קבצי מארגן",
    organizerFilesModalAddFile: "העלה קובץ חדש",

    uploadNewOrganizerFileModalTitle: "העלאת קובץ מארגן חדש",
    uploadNewOrganizerFileModalTitleDropOrClickFileHere:
      "לחץ או גרור קובץ לכאן",
    uploadNewOrganizerFileModalTitleDropFileHere: "לחץ או גרור קובץ לכאן",

    pdfFilePreview: "תצוגה מקדימה של קובץ PDF",

    createTransactionModalTitle: "יצירת עסקה חדשה עבור אירוע מארגן",
    selectOrganizerEvent: "בחירת אירוע של המארגן",
    eventNameSearchLabel: "חיפוש לפי שם האירוע",
    selectTransactionType: "בחירת סוג עסקה",
    transactionTypeService: "שירות",
    transactionTypeSimple: "עסקה",
    selectOrganizerBillAccount: "בחירת חשבון חיוב של המארגן",
    billAccountNameSearchLabel: "חיפוש לפי שם חשבון החיוב",
    successTransactionCreateMessage: "העסקה נוצרה בהצלחה",
    selectedEventName: "שם האירוע שנבחר:",
    totalEventAmount: "סכום כולל של האירוע",
    totalWithdrawnAmount: "סכום שנמשך בסך הכול",
    availableForWithdrawalAmount: "סכום זמין למשיכה",
    calculateData: "חישוב נתוני העסקה",
    totalTransactionAmount: "סכום כולל של העסקה",
    transactionAmount: "סכום העסקה",
    transactionFeeAmount: "סכום עמלת העסקה",
    fastWithdrawalFeeAmount: "סכום עמלת משיכה מהירה",
    warningOverdraftAmount: "עסקה זו תגרום לחריגה מהמסגרת!",
    overdraftAfterTransaction: "חריגה מהמסגרת לאחר יצירת העסקה",
    transactionAmountLabel: "סכום העסקה",
    transactionFeeAmountLabel: "סכום עמלת העסקה",
    transactionAdminWithdrawalFeeAmountLabel: "סכום עמלת משיכה אדמיניסטרטיבית",
    amountRequiredError: "יש להזין סכום",
    adminFeeRequiredError: "יש להזין סכום עמלת משיכה אדמיניסטרטיבית",
    numberMinError: "הערך חייב להיות גדול מ־0",
    transactionFastWithdrawalFeeAmountLabel: "סכום עמלת משיכה מהירה",
    transactionAdminNoteLabel: "הערת מנהל לעסקה",
    overdraftConfirmation: "אני מבין/ה שהעסקה תיווצר בחריגה מהמסגרת",
    transactionNameLabel: "שם העסקה",
    transactionNameRequiredError: "שם העסקה הוא שדה חובה",
    transactionNameMinError: "שם העסקה קצר מדי (מינימום 3 תווים)",
    formViewCreateButton: "יצירת עסקה",
    serviceFormViewCreateButton: "יצירת עסקת שירות",
    gridEventTransactionListItemAdminWithdrawal: "משיכה אדמיניסטרטיבית",
    gridEventTransactionListItemAdminFee: "עמלת משיכה אדמיניסטרטיבית",
    gridEventTransactionListItemOverdraft: "חריגה מהמסגרת 🚨",
  },
};
